(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4220,3818,2066,5693],{

/***/ 43832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1591);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'block'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Container(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(String(maxWidth)))]),
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(styles, {
  name: 'MuiContainer'
})(Container));

/***/ }),

/***/ 8920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(159);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99700);



function useTheme() {
  var theme = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)() || _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;

  if (false) {}

  return theme;
}

/***/ }),

/***/ 31353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports seoKeys, emptySeo */
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var seoKeys = {// NotFound: "notFound",
  // Homepage: "homePage",
  // firstHand: `firstHand_`, // use with car id. example: {firstHand_122123}
  // zeroKm: "zeroKm_", // use with car slug. example: {zeroKm_14/629/271/2021}
  // leasing: "leasing_", // use with car slug. example: {leasing_14/629/271/2021}
};

for (var key in seoKeys) {
  seoKeys[key] = encodeURIComponent(seoKeys[key].replace(/\/\[.+/, "").replace("/", "").replace(/-/g, " "));
}

var emptySeo = {
  title: " ",
  description: "",
  keywords: ""
};

var SeoMetaData = function SeoMetaData(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
      title: data.title,
      description: data.description || "",
      additionalMetaTags: [{
        name: "title",
        content: data.title
      }, {
        name: "keywords",
        content: data.keywords
      }, {
        name: "description",
        content: data.description
      }],
      openGraph: {
        title: data.title,
        description: data.description || ""
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["ZP"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(SeoMetaData));

/***/ }),

/***/ 36166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17812);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);
/* harmony import */ var _components_Icons_BackIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2936);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var StyledLink = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BackButton__StyledLink",
  componentId: "sc-18sathq-0"
})(["display:flex;cursor:pointer;p{margin-right:8px;}:hover{text-decoration:underline;}", " ", "{", "}"], function (p) {
  return (p === null || p === void 0 ? void 0 : p.$padding) && "padding: ".concat(p.$padding, ";");
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobilePadding) && "padding: ".concat(p === null || p === void 0 ? void 0 : p.$mobilePadding, ";");
});
var StyledIconBtn = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
  displayName: "BackButton__StyledIconBtn",
  componentId: "sc-18sathq-1"
})(["padding:1px;position:relative;bottom:2px;"]);
var StyledText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
  displayName: "BackButton__StyledText",
  componentId: "sc-18sathq-2"
})(["", "{", "}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$hideTextOnMobile) && "display: none;";
});

var BackButton = function BackButton(_ref) {
  var prevPath = _ref.prevPath,
      linkText = _ref.linkText,
      padding = _ref.padding,
      mobilePadding = _ref.mobilePadding,
      beforeNavigation = _ref.beforeNavigation,
      preventNavigation = _ref.preventNavigation,
      className = _ref.className,
      hideTextOnMobile = _ref.hideTextOnMobile,
      afterNavigation = _ref.afterNavigation;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(StyledLink, {
    className: className,
    $padding: padding,
    $mobilePadding: mobilePadding,
    onClick: function onClick() {
      if (beforeNavigation) {
        beforeNavigation();
      }

      if (preventNavigation) return;

      if (prevPath) {
        router.push(prevPath);
      } else {
        router.back();
      }

      afterNavigation && afterNavigation();
    },
    role: "button",
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        if (beforeNavigation) {
          beforeNavigation();
        }

        if (preventNavigation) return;

        if (prevPath) {
          router.push(prevPath);
        } else {
          router.back();
        }

        afterNavigation && afterNavigation();
      }
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledIconBtn, {
      "aria-label": "\u05D7\u05D6\u05E8\u05D4 \u05DC\u05E2\u05DE\u05D5\u05D3 \u05E7\u05D5\u05D3\u05DD",
      role: "presentation",
      tabIndex: -1,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_Icons_BackIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledText, {
      variant: "body1",
      $hideTextOnMobile: hideTextOnMobile,
      children: linkText
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BackButton);

/***/ }),

/***/ 78980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92208);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50066);
/* harmony import */ var _CreateAiContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90374);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var StyledBottomNavigation = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CreatePictureAiButton__StyledBottomNavigation",
  componentId: "sc-7pn3bq-0"
})(["height:70px;padding:10px;justify-content:center;background-color:", ";border-top-left-radius:10px;border-top-right-radius:10px;box-shadow:0 5px 15px 0 rgba(0,0,0,0.04);position:fixed;bottom:0;width:100%;z-index:1;right:0;", "{position:relative;width:300px;background-color:none;box-shadow:none;}"], function (p) {
  return p.theme.colors.white;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
});

var CreatePictureAiButton = function CreatePictureAiButton(_ref2) {
  var text = _ref2.text,
      enabledButton = _ref2.enabledButton,
      submit = _ref2.submit;

  var _useCreateAiContext = (0,_CreateAiContext__WEBPACK_IMPORTED_MODULE_1__/* .useCreateAiContext */ .uh)(),
      stylesData = _useCreateAiContext.stylesData,
      propertiesData = _useCreateAiContext.propertiesData,
      backgroundsData = _useCreateAiContext.backgroundsData;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(StyledBottomNavigation, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_GenericButton_GenericButton__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      btnType: "filled",
      disabled: !enabledButton ? !(stylesData && propertiesData.length > 0 && backgroundsData) : false,
      onClick: function onClick() {
        submit();
      },
      children: text
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (CreatePictureAiButton);

/***/ }),

/***/ 92208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(282);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




var StyledButtonContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_material_ui_core_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
  displayName: "GenericButton__StyledButtonContainer",
  componentId: "sc-r0056q-0"
})(["width:", ";", " ", " height:48px;", "{width:", ";", "}display:flex;justify-content:center;align-items:center;border-radius:8px;padding:8px 16px;font-family:NarkisBlock;font-size:24px;color:var(--Black,var(--Primary-Black,#000));cursor:pointer;", " ", " ", " ", ""], function (p) {
  return p !== null && p !== void 0 && p.$width ? "".concat(p === null || p === void 0 ? void 0 : p.$width, "px") : "328px";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$width) === "auto" && "width: auto;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$fullWidth) && "width: 100%;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p !== null && p !== void 0 && p.$mobileWidth ? "".concat(p === null || p === void 0 ? void 0 : p.$mobileWidth, "px") : "100%";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobileWidth) === "auto" && "width: auto;";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$btnType) === "filled" && !(p !== null && p !== void 0 && p.$disabled) && "\n      background: var(--Yellow, #ffbc0d);\n\n      &:hover {\n        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);\n        background: var(--Yellow, #ffbc0d);\n        font-size: 26px;\n      }\n\n      &:focus {\n        box-shadow: 0px 4px 8px 0px rgba(45, 45, 45, 0.16);\n      }\n\n      &:active {\n        background: #F5B511;\n      }\n    ";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$btnType) === "outlined" && !(p !== null && p !== void 0 && p.$disabled) && "\n      border: 2px solid var(--Yellow, #FFBC0D);\n      background: var(--White, #FFF);\n\n\n      &:hover {\n        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);\n        background: var(--White, #FFF);\n        font-size: 26px;\n      }\n\n      &:focus {\n        box-shadow: 0px 4.5px 9px 0px rgba(45, 45, 45, 0.16);\n      }\n\n      &:active {\n        background: rgba(247, 247, 247, 0.50);\n      }\n  ";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$disabled) && "\n      background: var(--Light-Grey, #F7F7F7);\n      color: rgba(45, 45, 45, 0.72);\n    ";
}, function (p) {
  return p.isdisabled && "\n    background: var(--Light-Grey, #f7f7f7);\n    color: rgba(45, 45, 45, 0.72);\n    font-size: 24px;\n    :hover {\n    background: var(--Light-Grey, #f7f7f7);\n\n  }\n  ";
});
var StyledIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "GenericButton__StyledIcon",
  componentId: "sc-r0056q-1"
})([""]);

var GenericButton = function GenericButton(_ref) {
  var btnType = _ref.btnType,
      width = _ref.width,
      mobileWidth = _ref.mobileWidth,
      icon = _ref.icon,
      children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      type = _ref.type,
      className = _ref.className,
      endIcon = _ref.endIcon,
      fullWidth = _ref.fullWidth,
      buttonHref = _ref.buttonHref,
      isdisabled = _ref.isdisabled;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledButtonContainer, {
    $width: width,
    $mobileWidth: mobileWidth,
    $btnType: btnType,
    $disabled: disabled,
    $fullWidth: fullWidth,
    onClick: onClick,
    disabled: disabled,
    type: type,
    isdisabled: isdisabled,
    className: className,
    href: buttonHref,
    children: [icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
      children: icon
    }), children, endIcon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledIcon, {
      children: endIcon
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GenericButton);

/***/ }),

/***/ 9108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ GenericInput; },
/* harmony export */   "p": function() { return /* binding */ errorAndFocusStyles; }
/* harmony export */ });
/* harmony import */ var components_QuickPurchasePage_Form_FormInput__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73033);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50066);


var errorAndFocusStyles = "\n// Focus and Error Handling\n\n  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    box-shadow: none !important;\n  }\n\n  .MuiOutlinedInput-root {\n    border-radius: 8px;\n    box-shadow: none;\n\n\n    fieldset {\n      border: 1px solid #e5e5e5; // Gray border when there's no focus or error\n      outline: none;\n    }\n\n    &.Mui-error {\n      fieldset {\n        border: 1px solid #db0007; // Red border for error\n      }\n\n      input {\n        font-size: 20px;\n      }\n    }\n\n    &:focus-within {\n      fieldset {\n        border: 1px solid #f7c600; // Yellow border on focus even with error\n        color: var(--Black, var(--Primary-Black, #000));\n      }\n    }\n\n    &.Mui-error:focus-within {\n      fieldset {\n        border: 1px solid #f7c600; // Ensure yellow border on focus with error\n        color: var(--Black, var(--Primary-Black, #000));\n      }\n    }\n  }\n\n  .MuiFormHelperText-root.Mui-error {\n    font-size: 14px;\n    margin-top:0;\n  }\n";
var GenericInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(components_QuickPurchasePage_Form_FormInput__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z).withConfig({
  displayName: "GenericInput",
  componentId: "sc-52hros-0"
})(["input[type=\"email\"]{font-size:20px;font-family:Speedee,NarkisBlock;direction:ltr;text-align:right;}.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl{width:", "px;height:", "px;", "}", "{.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl{width:", ";}}.MuiOutlinedInput-multiline{padding:23px 0px 18.5px 0;textarea{padding:0 8px;}}.MuiFormHelperText-root.MuiFormHelperText-contained{min-height:15px;}.Mui-focused{border:0;outline:0;box-shadow:0;}.MuiFormControl-root{", "}.MuiButtonBase-root.MuiIconButton-root{padding:12px 0 12px 12px;}.MuiOutlinedInput-adornedStart{padding-right:8px;}.MuiOutlinedInput-input{padding:16px 8px 0px 8px;", " font-family:Speedee,NarkisBlock;font-size:20px;font-style:normal;font-weight:400;line-height:normal;&:not(:focus){color:var(--Grey,#6f6f6f);}&:not(:focus){color:#000;}&.Mui-error:not(:focus){color:#000;}}.MuiInputLabel-root{font-size:18px;font-family:NarkisBlock;}.MuiInputLabel-outlined{transform:translate(-8px,16px);", "{transform:translate(-8px,18px);}}.MuiInputLabel-outlined.MuiInputLabel-shrink{transform:translate(-8px,8px) scale(1);", " color:var(--Grey,#757575);font-family:Speedee,NarkisBlock;font-size:14px;font-style:normal;font-weight:400;line-height:normal;letter-spacing:0.21px;}", " ", ""], function (p) {
  return (p === null || p === void 0 ? void 0 : p.$width) || "312";
}, function (p) {
  return p !== null && p !== void 0 && p.$height ? p === null || p === void 0 ? void 0 : p.$height : "56";
}, function (p) {
  return p.multiline ? (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["height:auto;min-height:", "px;"], p !== null && p !== void 0 && p.$height ? p === null || p === void 0 ? void 0 : p.$height : "56") : "";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobileWidth) || "100%";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$mobileWidth) && "width: ".concat(p.$mobileWidth, ";");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$hasIcon) && "padding: 16px 0 0px 8px;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$hasIcon) && "transform: translate(-44px, 8px) scale(1);";
}, function (p) {
  return (p === null || p === void 0 ? void 0 : p.$unicodeBidi) && "\n      input {\n        unicode-bidi: ".concat(function (p) {
    return p.$unicodeBidi;
  }, ";\n        text-align: right;\n\n      }\n    ");
}, errorAndFocusStyles);

/***/ }),

/***/ 2936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var SvgComponent = function SvgComponent() {
  var w = 31;
  var h = 31;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "back arrow",
    width: w,
    height: h,
    viewBox: "0 0 31 31",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
      "data-name": "Ellipse 6",
      cx: "15.5",
      cy: "15.5",
      r: "15.5",
      fill: "#f7f7f7"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
      "data-name": "Path 603",
      d: "M13.843 20.428a.5.5 0 0 1-.319-.881L18.38 15.5l-4.857-4.046a.5.5 0 1 1 .638-.766l5.316 4.43a.5.5 0 0 1 0 .765l-5.316 4.43a.5.5 0 0 1-.318.115z"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 85738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var SvgComponent = function SvgComponent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].coffeeBrown */ .Z.coffeeBrown : _ref$color,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var w = 24;
  var h = 25;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 ".concat(w, " ").concat(h),
    width: w,
    height: h,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("g", {
      clipPath: "url(#a)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: color,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
        d: "M17.781 6.266a.75.75 0 0 1 0 1.062l-10.5 10.5a.751.751 0 0 1-1.062-1.062l10.5-10.5a.75.75 0 0 1 1.062 0Z"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
        d: "M6.22 6.266a.75.75 0 0 0 0 1.062l10.5 10.5a.75.75 0 0 0 1.061-1.062l-10.5-10.5a.75.75 0 0 0-1.062 0Z"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("defs", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("path", {
          fill: "#fff",
          transform: "translate(0 .047)",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);

/***/ }),

/***/ 73033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16835);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85161);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64436);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);
/* harmony import */ var _Reusable_Bit_Form_FormikInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60137);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var _excluded = ["name", "label", "type", "required", "placeholder", "maxLength", "numeric", "InputProps", "centerField", "autoFocus", "topMargin", "autoComplete", "mobileTopMargin"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Styled = {
  Field: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_1__.Field).withConfig({
    displayName: "FormInput__Field",
    componentId: "sc-ju03wp-0"
  })(["width:100%;.MuiFormHelperText-root{font-size:20px;}.MuiFormHelperText-root.Mui-error{", ";}input{", "}"], function (p) {
    return p.$center ? "text-align: center;" : "";
  }, function (p) {
    return p.$center ? "text-align: center;" : "";
  }),
  FormControl: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    displayName: "FormInput__FormControl",
    componentId: "sc-ju03wp-1"
  })([""]),
  FieldWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormInput__FieldWrapper",
    componentId: "sc-ju03wp-2"
  })(["margin-top:", ";input{font-family:Speedee,NarkisBlock,sans-serif;color:#000;font-size:20px;font-weight:500;}input[type=\"email\"]{font-size:16px;font-family:sans-serif,Speedee;font-weight:normal;}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;}.MuiOutlinedInput-root.Mui-error{fieldset{box-shadow:none;border:1px solid #db0007;top:0px;border-radius:8px;height:56px;}}.MuiOutlinedInput-root{border-radius:8px;box-shadow:none;}.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl{border-radius:8px;background:#fff;}.MuiFormLabel-root.Mui-error{color:#000;font-family:NarkisBlock;}", "{", " fieldset{min-height:50px;}}"], function (p) {
    return p.$topMargin ? "".concat(p.$topMargin, "px") : "28px";
  }, function (p) {
    return p.theme.breakpoints.down("sm");
  }, function (p) {
    return (p === null || p === void 0 ? void 0 : p.$mobileTopMargin) && "margin-top: ".concat(p.$mobileTopMargin, "px;");
  }),
  LabelWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormInput__LabelWrapper",
    componentId: "sc-ju03wp-3"
  })(["display:flex;align-items:center;"]),
  InputLabel: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "FormInput__InputLabel",
    componentId: "sc-ju03wp-4"
  })(["transform:none !important;font-size:18px;color:", ";font-weight:400;", ";line-height:1.44;margin-top:5px;"], function (p) {
    return p.theme.colors.darkGrey;
  }, function (p) {
    return p.$center ? "width: 100%; right: none; text-align: center;" : "";
  }),
  BottomText: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
    variant: "body1"
  }).withConfig({
    displayName: "FormInput__BottomText",
    componentId: "sc-ju03wp-5"
  })(["text-align:start;font-size:15px;margin-top:-23px;color:", ";"], function (p) {
    return p.theme.colors.marbleGrey;
  })
};

var FormInput = function FormInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      placeholder = _ref.placeholder,
      maxLength = _ref.maxLength,
      numeric = _ref.numeric,
      InputProps = _ref.InputProps,
      centerField = _ref.centerField,
      autoFocus = _ref.autoFocus,
      topMargin = _ref.topMargin,
      autoComplete = _ref.autoComplete,
      mobileTopMargin = _ref.mobileTopMargin,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var _useField = (0,formik__WEBPACK_IMPORTED_MODULE_1__.useField)(name),
      _useField2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_useField, 1),
      field = _useField2[0];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Styled.FieldWrapper, {
      $topMargin: topMargin,
      $mobileTopMargin: mobileTopMargin,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Reusable_Bit_Form_FormikInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
        name: name,
        type: type,
        required: required,
        placeholder: placeholder,
        maxLength: maxLength,
        numeric: numeric,
        centerField: centerField,
        InputProps: InputProps,
        autoFocus: autoFocus,
        label: label,
        autoComplete: autoComplete
      }, field), props))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormInput);

/***/ }),

/***/ 34968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73192);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(focus_formik_error__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








function FormikForm(_ref) {
  var validationSchema = _ref.validationSchema,
      initialValues = _ref.initialValues,
      render = _ref.render,
      onSubmit = _ref.onSubmit,
      validate = _ref.validate,
      innerRef = _ref.innerRef,
      alwaysValidate = _ref.alwaysValidate;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      formIsDirty = _useState[0],
      setFormIsDirty = _useState[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(formik__WEBPACK_IMPORTED_MODULE_2__.Formik, {
    validate: validate,
    innerRef: innerRef,
    initialValues: initialValues,
    validationSchema: validationSchema,
    validateOnMount: false,
    validateOnChange: alwaysValidate || formIsDirty,
    validateOnBlur: alwaysValidate || formIsDirty,
    onSubmit: /*#__PURE__*/function () {
      var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(values, actions) {
        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                actions.setSubmitting(true);
                _context.next = 3;
                return onSubmit(values, actions);

              case 3:
                actions.setSubmitting(false);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(),
    enableReinitialize: true,
    children: function children(formik) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_2__.Form, {
        noValidate: true,
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          setFormIsDirty(true); // changes formkit.validateOnChange state to true

          return formik.handleSubmit();
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(focus_formik_error__WEBPACK_IMPORTED_MODULE_1__.ConnectedFocusError, {}), render(formik)]
      });
    }
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (FormikForm);

/***/ }),

/***/ 60137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82175);
/* harmony import */ var formik_material_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74938);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["name", "label", "type", "required", "placeholder", "maxLength", "numeric", "InputProps", "centerField", "autoFocus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var Styled = {
  Field: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_1__.Field).withConfig({
    displayName: "FormikInput__Field",
    componentId: "sc-1jyipnl-0"
  })(["width:100%;.MuiFormHelperText-root{font-size:18px;font-family:Speedee,NarkisBlock-Thin,sans-serif;}.MuiFormHelperText-root.Mui-error{", ";color:#d70202;}input{", "}"], function (p) {
    return p.$center ? "text-align: center;" : "";
  }, function (p) {
    return p.$center ? "text-align: center;" : "";
  })
};

// todo the error messageis not working!
var FormikInput = function FormikInput(_ref) {
  var name = _ref.name,
      label = _ref.label,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      placeholder = _ref.placeholder,
      maxLength = _ref.maxLength,
      numeric = _ref.numeric,
      InputProps = _ref.InputProps,
      centerField = _ref.centerField,
      autoFocus = _ref.autoFocus,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Styled.Field, _objectSpread({
    $center: centerField,
    label: label,
    component: formik_material_ui__WEBPACK_IMPORTED_MODULE_2__/* .TextField */ .nv,
    id: name,
    name: name,
    type: type,
    required: required,
    helperText: " ",
    placeholder: placeholder,
    inputProps: {
      maxLength: maxLength,
      inputMode: numeric && "numeric",
      pattern: numeric && "[0-9]*",
      style: {
        direction: type === "tel" ? "rtl" : undefined
      }
    },
    InputProps: _objectSpread({}, InputProps),
    autoFocus: autoFocus,
    variant: "outlined"
  }, props));
};

/* harmony default export */ __webpack_exports__["Z"] = (FormikInput);

/***/ }),

/***/ 16110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["href", "passHref", "children", "openInNewTab", "noScrollToTop", "ariaLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var NextLink = function NextLink(_ref) {
  var href = _ref.href,
      passHref = _ref.passHref,
      children = _ref.children,
      _ref$openInNewTab = _ref.openInNewTab,
      openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab,
      _ref$noScrollToTop = _ref.noScrollToTop,
      noScrollToTop = _ref$noScrollToTop === void 0 ? false : _ref$noScrollToTop,
      ariaLabel = _ref.ariaLabel,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  // const { asPath } = useRouter()
  // const idx = asPath.indexOf("?")
  // const search = idx >= 0 ? asPath.slice(idx) : undefined
  // const link: UrlObject = {
  //   pathname: href,
  //   // search
  //  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: href,
    passHref: true,
    scroll: !noScrollToTop,
    children: openInNewTab ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({
      target: "_blank",
      rel: "noreferrer"
    }, props), {}, {
      "aria-label": ariaLabel,
      children: children
    })) : passHref ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({}, props), {}, {
      "aria-label": ariaLabel,
      children: children
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(NextLink));

/***/ }),

/***/ 26490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41810);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var StyledContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SingleButtonSelection__StyledContainer",
  componentId: "sc-1586vsq-0"
})(["display:flex;flex-wrap:wrap;"]);
var StyledButtonWrap = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_material_ui_core_ButtonBase__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "SingleButtonSelection__StyledButtonWrap",
  componentId: "sc-1586vsq-1"
})(["width:", ";"], function (props) {
  return props.$itemsPerRow === "auto" ? "auto" : "calc(100% / ".concat(props.$itemsPerRow, " - ").concat(props.$gap, "px * (").concat(props.$itemsPerRow, " - 1) / ").concat(props.$itemsPerRow, ") ");
});
var StyledLabel = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].label.withConfig */ .ZP.label.withConfig({
  displayName: "SingleButtonSelection__StyledLabel",
  componentId: "sc-1586vsq-2"
})(["width:100%;height:44px;border:solid 1px transparent;position:relative;display:flex;align-items:center;justify-content:center;border-radius:5px;background-color:#fff;font-size:16px;direction:", ";cursor:pointer;position:relative;", " @media print{display:none;justify-content:flex-start;box-shadow:none;background-image:none !important;span{justify-content:flex-start;}}b{font-size:1.5em;}span{width:100%;height:100%;display:flex;align-items:center;justify-content:center;position:absolute;inset:0;line-height:1;}", ""], function (p) {
  return p.$isBattery ? "ltr" : "rtl";
}, function (p) {
  return !p.$isBattery && "box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);";
}, function (p) {
  return p.$isBattery ? "\n    background-image:url('/battery-disabled.svg');\n    background-size:contain;\n    background-repeat:no-repeat;\n    border:none;\n    height: 0;\n    padding-bottom: calc( 100% * 59 / 232);\n    position: relative;\n\n  " : "background-image:none !important;";
});
var StyledRadio = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "SingleButtonSelection__StyledRadio",
  componentId: "sc-1586vsq-3"
})(["position:absolute;border:0;margin:-1px;padding:0;border-radius:50%;width:1px;height:1px;opacity:0;:checked + ", "{border-color:", ";color:", ";background-image:url(\"/battery-button.svg\");@media print{display:block;border:none;}}:focus + ", "{border-color:", ";color:", ";background-image:url(\"/battery-button.svg\");@media print{display:block;border:none;}}:hover{border:2px solid black;}:focus-visible{border:3px solid ", " !important;}"], StyledLabel, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.black;
}, StyledLabel, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, function (p) {
  return p.theme.colors.darkYellow;
});
var SingleButtonSelection = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function (_ref5, bgRef) {
  var id = _ref5.id,
      items = _ref5.items,
      onSelect = _ref5.onSelect,
      isBattery = _ref5.isBattery,
      customButton = _ref5.customButton,
      selectedValue = _ref5.selectedValue,
      className = _ref5.className,
      _ref5$itemsPerRow = _ref5.itemsPerRow,
      itemsPerRow = _ref5$itemsPerRow === void 0 ? 2 : _ref5$itemsPerRow,
      _ref5$gap = _ref5.gap,
      gap = _ref5$gap === void 0 ? 10 : _ref5$gap,
      _ref5$allowEmpty = _ref5.allowEmpty,
      allowEmpty = _ref5$allowEmpty === void 0 ? false : _ref5$allowEmpty,
      _ref5$noFocus = _ref5.noFocus,
      noFocus = _ref5$noFocus === void 0 ? false : _ref5$noFocus;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(allowEmpty ? selectedValue : selectedValue || items[0].value),
      selectedButton = _useState[0],
      setSelectedButton = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!items || !items.length || !selectedValue) {
      return;
    }

    setSelectedButton(selectedValue || items[0].value);
  }, [items, selectedValue]);

  var handleChange = function handleChange(value, index) {
    setSelectedButton(value);
    onSelect(value, index);
  };

  return (
    /*#__PURE__*/
    // <RowWithTitle {...{ title, id, headlineComponent }} noPrint={!isBattery}>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContainer, {
      role: "radiogroup",
      "aria-labelledby": id,
      $gap: gap,
      className: className,
      children: items.map(function (item, index) {
        var _item$name;

        var radioId = "radio_".concat(id, "_").concat(item.value);
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledButtonWrap, {
          tabIndex: noFocus ? -1 : undefined,
          role: "presentation",
          $itemsPerRow: itemsPerRow,
          $gap: gap,
          "aria-label": item !== null && item !== void 0 && item.ariaLabel ? item === null || item === void 0 ? void 0 : item.ariaLabel : index === 0 ? "".concat(item.name, " \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05E8\u05E7\u05E2 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D4\u05DE\u05EA\u05E0\u05D4, \u05E0\u05D5\u05D5\u05D8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D4\u05D7\u05E6\u05D9\u05DD") : item.name,
          onKeyDown: function onKeyDown(e) {
            if (e.key === "Enter") {
              handleChange(item.value, index);
              setSelectedButton(item.value);
            }
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledRadio, {
            "aria-label": index === 0 ? "".concat(item.name, " \u05DB\u05D3\u05D9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05E8\u05E7\u05E2 \u05DC\u05DB\u05E8\u05D8\u05D9\u05E1 \u05D4\u05DE\u05EA\u05E0\u05D4, \u05E0\u05D5\u05D5\u05D8 \u05D1\u05D0\u05DE\u05E6\u05E2\u05D5\u05EA \u05D4\u05D7\u05E6\u05D9\u05DD") : item.name,
            ref: index === 0 ? bgRef : null,
            type: "radio",
            name: id,
            value: item.value,
            tabIndex: !noFocus ? -1 : undefined,
            id: radioId,
            checked: item.value === selectedButton // disabled={!color.details.inStock}
            ,
            onChange: function onChange() {
              handleChange(item.value, index);
              setSelectedButton(item.value);
            }
          }), customButton ? customButton(radioId, item.value === selectedButton, item, index) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledLabel, {
            $isBattery: isBattery,
            htmlFor: radioId,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
              children: [item.secondaryName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("b", {
                children: [item.secondaryName.toUpperCase(), "\xA0"]
              }), (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toUpperCase()]
            })
          })]
        }, item.value);
      })
    }) // </RowWithTitle>

  );
});
SingleButtonSelection.displayName = "SingleButtonSelection";
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(SingleButtonSelection));

/***/ }),

/***/ 44019:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 7942:
/***/ (function(module, exports, __webpack_require__) {

"client";
"use strict";

var _slicedToArray = __webpack_require__(85696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(17273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var _router = __webpack_require__(64957);

var _addLocale = __webpack_require__(57995);

var _routerContext = __webpack_require__(30647);

var _appRouterContext = __webpack_require__(51992);

var _useIntersection = __webpack_require__(90639);

var _getDomainLocale = __webpack_require__(44019);

var _addBasePath = __webpack_require__(70227);

'client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push';
      router[method](href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}

var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(false) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react["default"].useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 51992:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(67294));

var AppRouterContext = _react["default"].createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react["default"].createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react["default"].createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react["default"].createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 80041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ create_ai; }
});

// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(31353);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./components/BackButton/BackButton.tsx
var BackButton = __webpack_require__(36166);
// EXTERNAL MODULE: ./components/PurchasePage/GroupPurchasesContext.tsx
var GroupPurchasesContext = __webpack_require__(28218);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(75741);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// EXTERNAL MODULE: ./components/Reusable/Bit/SingleButtonSelection.tsx
var SingleButtonSelection = __webpack_require__(26490);
// EXTERNAL MODULE: ./components/CreateAi/CreateAiContext.tsx
var CreateAiContext = __webpack_require__(90374);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/CreateAi/BackgroundsAi.tsx











var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h2",
  variant: "h2"
}).withConfig({
  displayName: "BackgroundsAi__StyledTitle",
  componentId: "sc-tqmyjt-0"
})(["color:", ";white-space:nowrap;font-size:26px;line-height:0.6;font-family:Speedee,NarkisBlock,sans-serif;margin-bottom:16px;text-align:right;", "{}"], colors/* default.black */.Z.black, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledLabel = styled_components_browser_esm/* default.label.withConfig */.ZP.label.withConfig({
  displayName: "BackgroundsAi__StyledLabel",
  componentId: "sc-tqmyjt-1"
})(["cursor:pointer;width:104px;height:116px;position:relative;display:flex;flex-direction:column;align-items:center;gap:4px;padding:4px;border-radius:8px;margin-bottom:16px;&:not(:nth-child(3n)){margin-left:8px !important;}border:1px solid ", ";opacity:", ";", "{width:160px;height:178px;}"], function (p) {
  return p.$noOneSelected ? p.theme.colors.disabled : p.$activeButton ? p.theme.colors.darkGreen : p.theme.colors.disabled;
}, function (p) {
  return p.$noOneSelected ? 1 : p.$activeButton ? 1 : 0.5;
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledSingleButtonSelection = (0,styled_components_browser_esm/* default */.ZP)(SingleButtonSelection/* default */.Z).withConfig({
  displayName: "BackgroundsAi__StyledSingleButtonSelection",
  componentId: "sc-tqmyjt-2"
})(["display:flex;flex-wrap:wrap;margin-bottom:32px;", "{padding:0 8px;}", "{gap:24px;margin-bottom:60px;.MuiButtonBase-root{width:160px;height:178px;}}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledExplanation = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "BackgroundsAi__StyledExplanation",
  componentId: "sc-tqmyjt-3"
})(["font-size:24px;font-weight:100;color:#000;line-height:0.92;text-align:right;margin-top:4px;", "{font-size:18px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "BackgroundsAi__StyledImage",
  componentId: "sc-tqmyjt-4"
})(["position:absolute;right:8px;top:8px;width:20px;height:20px;"]);
var StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "BackgroundsAi__StyledError",
  componentId: "sc-tqmyjt-5"
})(["color:#d70202;font-size:18px;line-height:1;position:absolute;bottom:-16px;margin:0px;"]);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "BackgroundsAi__StyledWrapper",
  componentId: "sc-tqmyjt-6"
})(["position:relative;"]);
var BackgroundsAi = /*#__PURE__*/(0,react.forwardRef)(function (_ref, bgRef) {
  var _backgrounds$, _backgrounds$2, _backgrounds$2$tags;

  var backgrounds = _ref.backgrounds,
      checkValiation = _ref.checkValiation;

  var _useCreateAiContext = (0,CreateAiContext/* useCreateAiContext */.uh)(),
      setBackgroundsData = _useCreateAiContext.setBackgroundsData,
      backgroundsData = _useCreateAiContext.backgroundsData;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
      children: (_backgrounds$ = backgrounds[0]) === null || _backgrounds$ === void 0 ? void 0 : _backgrounds$.name
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSingleButtonSelection, {
      id: "amount",
      ref: bgRef,
      items: (_backgrounds$2 = backgrounds[0]) === null || _backgrounds$2 === void 0 ? void 0 : (_backgrounds$2$tags = _backgrounds$2.tags) === null || _backgrounds$2$tags === void 0 ? void 0 : _backgrounds$2$tags.map(function (background) {
        return {
          value: background.id,
          name: background.name
        };
      }),
      onSelect: function onSelect(code) {
        var _backgrounds$3;

        setBackgroundsData((_backgrounds$3 = backgrounds[0]) === null || _backgrounds$3 === void 0 ? void 0 : _backgrounds$3.tags.find(function (b) {
          return b.id === code;
        }).id);
      },
      gap: 15,
      itemsPerRow: lib/* isDesktop */.nI ? 5 : "auto",
      selectedValue: backgroundsData,
      allowEmpty: true,
      customButton: function customButton(radioId, isSelected, item, index) {
        var _backgrounds$4, _backgrounds$4$tags$i, _backgrounds$5, _backgrounds$5$tags$i, _backgrounds$6, _backgrounds$6$tags$i;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLabel, {
            htmlFor: radioId,
            $noOneSelected: !backgroundsData,
            $activeButton: item.value === backgroundsData,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: (_backgrounds$4 = backgrounds[0]) === null || _backgrounds$4 === void 0 ? void 0 : (_backgrounds$4$tags$i = _backgrounds$4.tags[index]) === null || _backgrounds$4$tags$i === void 0 ? void 0 : _backgrounds$4$tags$i.image.imageUrl,
              alt: (_backgrounds$5 = backgrounds[0]) === null || _backgrounds$5 === void 0 ? void 0 : (_backgrounds$5$tags$i = _backgrounds$5.tags[index]) === null || _backgrounds$5$tags$i === void 0 ? void 0 : _backgrounds$5$tags$i.image.alt,
              width: lib/* isDesktop */.nI ? 144 : 96,
              height: lib/* isDesktop */.nI ? 128 : 80
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImage, {
              src: isSelected ? "/img/icons/RadiobuttonChecked.png" : "/img/icons/Radiobutton.png",
              alt: "check-icon"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExplanation, {
              children: (_backgrounds$6 = backgrounds[0]) === null || _backgrounds$6 === void 0 ? void 0 : (_backgrounds$6$tags$i = _backgrounds$6.tags[index]) === null || _backgrounds$6$tags$i === void 0 ? void 0 : _backgrounds$6$tags$i.name
            })]
          })
        });
      }
    }), !backgroundsData && checkValiation && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledError, {
      children: "\u05D9\u05E9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05E8\u05E7\u05E2"
    })]
  });
});
BackgroundsAi.displayName = "BackgroundsAi";
/* harmony default export */ var CreateAi_BackgroundsAi = (BackgroundsAi);
// EXTERNAL MODULE: ./components/PurchasePage/PurchaseContext.tsx
var PurchaseContext = __webpack_require__(33574);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(72821);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./components/CreateAi/CategoriesAi.tsx















var StyledCategories = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CategoriesAi__StyledCategories",
  componentId: "sc-87of33-0"
})(["margin-bottom:40px;"]);
var CategoriesAi_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h2",
  variant: "h2"
}).withConfig({
  displayName: "CategoriesAi__StyledTitle",
  componentId: "sc-87of33-1"
})(["color:", ";white-space:nowrap;font-size:26px;line-height:0.6;font-family:Speedee,NarkisBlock,sans-serif;margin-bottom:16px;text-align:right;"], colors/* default.black */.Z.black);
var StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
  displayName: "CategoriesAi__StyledSwiper",
  componentId: "sc-87of33-2"
})(["width:100%;height:100%;margin-bottom:60px;margin-top:13px;&:last-child{margin-bottom:60px;}", "{margin-bottom:40px;.swiper-slide{-webkit-backface-visibility:hidden;-webkit-transform:translate3d(0,0,0);}}", "{.swiper-slide{text-align:center;font-size:18px;background:", ";display:flex;justify-content:center;align-items:center;flex-direction:column;align-items:start;width:auto;}}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, colors/* default.white */.Z.white);
var StyledCategory = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "CategoriesAi__StyledCategory",
  componentId: "sc-87of33-3"
})(["height:104px;width:116px;display:flex;flex-direction:column;align-items:center;padding:4px;border:solid 1px ", ";border-radius:8px;background-color:white;gap:4px;", "{height:178px;width:160px;cursor:pointer;}"], function (p) {
  return p.$isSelected ? colors/* default.darkGreen */.Z.darkGreen : colors/* default.disabled */.Z.disabled;
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var swiperBreakpoints = {
  640: {
    slidesPerView: "auto",
    slidesPerGroup: 1,
    slidesOffsetBefore: 0
  }
};
var CategoriesAi_StyledExplanation = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "CategoriesAi__StyledExplanation",
  componentId: "sc-87of33-4"
})(["font-size:24px;font-weight:100;color:", ";line-height:0.92;text-align:right;", "{font-size:18px;}"], function (p) {
  return p.$isSelected ? colors/* default.black */.Z.black : colors/* default.warmGray */.Z.warmGray;
}, function (p) {
  return p.theme.breakpoints.down("sm");
});

var CategoriesAi = function CategoriesAi(_ref) {
  var categories = _ref.categories;

  var _usePurchaseContext = (0,PurchaseContext/* usePurchaseContext */.AX)(),
      categoryName = _usePurchaseContext.categoryName;

  var _useCreateAiContext = (0,CreateAiContext/* useCreateAiContext */.uh)(),
      blessingId = _useCreateAiContext.blessingId,
      setBlessingId = _useCreateAiContext.setBlessingId,
      setPropertiesData = _useCreateAiContext.setPropertiesData;

  (0,react.useEffect)(function () {
    if (!blessingId && categories) {
      var _categories$;

      setBlessingId((_categories$ = categories[0]) === null || _categories$ === void 0 ? void 0 : _categories$.blessingId);
    }
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCategories, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesAi_StyledTitle, {
      children: "\u05E7\u05D8\u05D2\u05D5\u05E8\u05D9\u05D5\u05EA"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSwiper, {
      slidesPerView: 2.75,
      spaceBetween: lib/* isDesktop */.nI ? 30 : -15,
      slidesPerGroup: 2,
      loop: false,
      loopFillGroupWithBlank: true,
      modules: [swiper_esm/* Pagination */.tl, swiper_esm/* Navigation */.W_] // @ts-ignore
      ,
      breakpoints: swiperBreakpoints,
      slidesOffsetBefore: lib/* isDesktop */.nI && 2,
      children: categories === null || categories === void 0 ? void 0 : categories.map(function (data) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledCategory, {
            $isSelected: blessingId === data.blessingId,
            onClick: function onClick() {
              if (blessingId !== data.blessingId) {
                setPropertiesData([]);
              }

              setBlessingId(data.blessingId);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: data.image.imageUrl,
              alt: data.image.alt,
              width: lib/* isDesktop */.nI ? 144 : 96,
              height: lib/* isDesktop */.nI ? 128 : 80
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesAi_StyledExplanation, {
              $isSelected: categoryName === data.name,
              children: data.categoryName
            })]
          }, data.blessingId)
        }, data.blessingId);
      })
    })]
  });
};

/* harmony default export */ var CreateAi_CategoriesAi = (CategoriesAi);
// EXTERNAL MODULE: ./components/CreateAi/CreatePictureAiButton.tsx
var CreatePictureAiButton = __webpack_require__(78980);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./components/Icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(85738);
;// CONCATENATED MODULE: ./components/CreateAi/PropertiesAi.tsx










var StyledTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PropertiesAi__StyledTitleContainer",
  componentId: "sc-1r6qw3y-0"
})(["", "{display:flex;align-items:center;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var PropertiesAi_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h2",
  variant: "h2"
}).withConfig({
  displayName: "PropertiesAi__StyledTitle",
  componentId: "sc-1r6qw3y-1"
})(["color:", ";white-space:nowrap;font-size:26px;line-height:0.6;font-family:Speedee,NarkisBlock,sans-serif;margin-bottom:16px;text-align:right;position:relative;", "{margin-left:16px;&:after{content:\"\";width:1px;margin-right:16px;height:32px;position:absolute;background-color:", ";top:-10px;}}"], colors/* default.black */.Z.black, function (p) {
  return p.theme.breakpoints.up("md");
}, colors/* default.black */.Z.black);
var PropertiesAi_StyledExplanation = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PropertiesAi__StyledExplanation",
  componentId: "sc-1r6qw3y-2"
})(["font-size:24px;font-weight:100;color:#000;line-height:0.92;text-align:right;margin-bottom:16px;", "{font-size:18px;}", "{margin-right:16px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledPropertiesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PropertiesAi__StyledPropertiesContainer",
  componentId: "sc-1r6qw3y-3"
})(["display:flex;flex-wrap:wrap;gap:16px;margin-bottom:40px;position:relative;", "{gap:24px;margin-bottom:60px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledProperty = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "PropertiesAi__StyledProperty",
  componentId: "sc-1r6qw3y-4"
})(["color:", ";width:auto;height:50px;padding:0 ", ";display:flex;font-weight:", ";align-items:center;opacity:", ";border:1px solid ", ";border-radius:8px;background:var(--White,#fff);", "{cursor:pointer;}font-family:\"NarkisBlock-Thin\";font-size:24px;&:hover{border:2px solid var(--Grey,#757575);}"], function (p) {
  return p.$isSelected ? colors/* default.darkGreen */.Z.darkGreen : colors/* default.warmGray */.Z.warmGray;
}, function (p) {
  return p.$isSelected ? "8px" : "16px";
}, function (p) {
  return p.$isSelected ? "700" : "400";
}, function (p) {
  return p.$isNotSelected ? "0.5" : "1";
}, function (p) {
  return p.$isSelected ? "#FFBC0D" : "#E5E5E5";
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var PropertiesAi_StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "PropertiesAi__StyledError",
  componentId: "sc-1r6qw3y-5"
})(["color:#d70202;font-size:18px;line-height:1;position:absolute;bottom:-24px;margin:0px;"]);
var PropertiesAi = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var _properties$, _properties$2, _properties$3;

  var properties = _ref.properties,
      checkValiation = _ref.checkValiation;

  var _useCreateAiContext = (0,CreateAiContext/* useCreateAiContext */.uh)(),
      propertiesData = _useCreateAiContext.propertiesData,
      setPropertiesData = _useCreateAiContext.setPropertiesData;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTitleContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PropertiesAi_StyledTitle, {
        children: (_properties$ = properties[0]) === null || _properties$ === void 0 ? void 0 : _properties$.name
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PropertiesAi_StyledExplanation, {
        children: ["\u05D9\u05E9 \u05DC\u05DA \u05D0\u05E4\u05E9\u05E8\u05D5\u05EA \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E2\u05D3 ", (_properties$2 = properties[0]) === null || _properties$2 === void 0 ? void 0 : _properties$2.maxToSelect, " \u05DE\u05D0\u05E4\u05D9\u05D9\u05E0\u05D9\u05DD", " "]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledPropertiesContainer, {
      children: [(_properties$3 = properties[0]) === null || _properties$3 === void 0 ? void 0 : _properties$3.tags.map(function (property, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledProperty, {
          "aria-label": propertiesData.length === 0 && checkValiation && i === 0 ? "   \u05D9\u05E9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA \u05DE\u05D0\u05E4\u05D9\u05D9\u05DF \u05D0\u05D7\u05D3.".concat(property.name, " ") : !(propertiesData !== null && propertiesData !== void 0 && propertiesData.includes(property.id)) ? property.name : "\u05DC\u05B0\u05D4\u05B7\u05E1\u05B4\u05D9\u05E8 \u05EA\u05DB\u05D5\u05E0\u05D4 ".concat(property.name),
          ref: i === 0 ? ref : null // Assign ref only to the first element
          ,
          $isSelected: propertiesData === null || propertiesData === void 0 ? void 0 : propertiesData.includes(property === null || property === void 0 ? void 0 : property.id),
          $isNotSelected: (propertiesData === null || propertiesData === void 0 ? void 0 : propertiesData.length) === properties[0].maxToSelect && !(propertiesData !== null && propertiesData !== void 0 && propertiesData.includes(property.id)),
          onClick: function onClick() {
            var _properties$4;

            if (propertiesData !== null && propertiesData !== void 0 && propertiesData.includes(property.id)) {
              setPropertiesData(propertiesData === null || propertiesData === void 0 ? void 0 : propertiesData.filter(function (item) {
                return item != property.id;
              }));
              return;
            }

            if ((propertiesData === null || propertiesData === void 0 ? void 0 : propertiesData.length) < ((_properties$4 = properties[0]) === null || _properties$4 === void 0 ? void 0 : _properties$4.maxToSelect)) {
              setPropertiesData([].concat((0,toConsumableArray/* default */.Z)(propertiesData), [property.id]));
            }
          },
          children: [(propertiesData === null || propertiesData === void 0 ? void 0 : propertiesData.includes(property.id)) && /*#__PURE__*/(0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {
            onClick: function onClick() {
              return setPropertiesData(propertiesData === null || propertiesData === void 0 ? void 0 : propertiesData.filter(function (p) {
                return p !== property.id;
              }));
            }
          }), property.name]
        }, i);
      }), propertiesData.length === 0 && checkValiation && /*#__PURE__*/(0,jsx_runtime.jsx)(PropertiesAi_StyledError, {
        role: "alert",
        "aria-live": "polite",
        children: "\u05D9\u05E9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DC\u05E4\u05D7\u05D5\u05EA \u05DE\u05D0\u05E4\u05D9\u05D9\u05DF \u05D0\u05D7\u05D3"
      })]
    })]
  });
});
PropertiesAi.displayName = "PropertiesAi";
/* harmony default export */ var CreateAi_PropertiesAi = (PropertiesAi);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./components/GenericInput/GenericInput.tsx
var GenericInput = __webpack_require__(9108);
// EXTERNAL MODULE: ./components/QuickPurchasePage/Form/FormInput.tsx
var FormInput = __webpack_require__(73033);
// EXTERNAL MODULE: ./components/Reusable/Bit/Form/FormikForm.tsx
var FormikForm = __webpack_require__(34968);
// EXTERNAL MODULE: ./components/Reusable/Bit/NextLink.tsx
var NextLink = __webpack_require__(16110);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
;// CONCATENATED MODULE: ./components/CreateAi/SenderAi.tsx



















var SenderAi_StyledTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SenderAi__StyledTitleContainer",
  componentId: "sc-1si74cw-0"
})(["", "{display:flex;align-items:center;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var SenderAi_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h2",
  variant: "h2"
}).withConfig({
  displayName: "SenderAi__StyledTitle",
  componentId: "sc-1si74cw-1"
})(["color:", ";white-space:nowrap;font-size:26px;line-height:0.6;font-family:Speedee,NarkisBlock,sans-serif;margin-bottom:16px;text-align:right;position:relative;", "{margin-left:16px;&:after{content:\"\";width:1px;margin-right:16px;height:32px;position:absolute;background-color:", ";top:-10px;}}"], colors/* default.black */.Z.black, function (p) {
  return p.theme.breakpoints.up("md");
}, colors/* default.black */.Z.black);
var SenderAi_StyledExplanation = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "SenderAi__StyledExplanation",
  componentId: "sc-1si74cw-2"
})(["font-size:24px;font-weight:100;color:#000;line-height:0.92;text-align:right;margin-bottom:16px;", "{font-size:18px;}", "{margin-right:16px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledBlessingAiValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SenderAi__StyledBlessingAiValue",
  componentId: "sc-1si74cw-3"
})(["width:200px;color:", ";border:solid 1px ", ";border-radius:4px;margin-bottom:32px;font-size:14px;display:flex;align-items:center;padding:0 8px;gap:8px;font-family:Speedee,NarkisBlock,sans-serif;font-size:18px;"], colors/* default.black */.Z.black, colors/* default.disabled */.Z.disabled);
var StyledTextBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "SenderAi__StyledTextBox",
  componentId: "sc-1si74cw-4"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;margin-top:-32px;margin-bottom:60px;", "{width:680px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "SenderAi__StyledTypography",
  componentId: "sc-1si74cw-5"
})(["font-size:18px;"]);
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "SenderAi__StyledText",
  componentId: "sc-1si74cw-6"
})(["font-family:\"NarkisBlock\",sans-serif;font-weight:400;font-size:18px;z-index:1;a{margin-left:5px;text-decoration:underline;}"]);
var StyledFormInput = (0,styled_components_browser_esm/* default */.ZP)(FormInput/* default */.Z).withConfig({
  displayName: "SenderAi__StyledFormInput",
  componentId: "sc-1si74cw-7"
})([".MuiInputBase-root{border:none;min-height:80px;", "{textarea{font-size:20px;}}", "{width:680px;min-height:120px;textarea{font-size:18px;}}}", " .MuiInputLabel-outlined{transform:translate(-21px,9px) scale(1);font-size:18px;color:var(--Grey,#757575);}.MuiInputLabel-outlined.MuiInputLabel-shrink{transform:translate(-13px,5px) scale(1);font-size:18px;}textarea{position:relative;top:6px;}", "{.MuiOutlinedInput-input{position:relative;top:26px;}}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
}, GenericInput/* errorAndFocusStyles */.p, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledFormContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SenderAi__StyledFormContainer",
  componentId: "sc-1si74cw-8"
})(["display:flex;justify-content:flex-start;", "{.MuiFormControl-root{width:100%;}}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var validationSchema = es/* object */.Ry().shape({
  senderBlessingAi: es/* string */.Z_()
});
var initialValues = {
  senderBlessingAi: ""
};

var SenderAi = function SenderAi() {
  var _useCreateAiContext = (0,CreateAiContext/* useCreateAiContext */.uh)(),
      senderBlessingAi = _useCreateAiContext.senderBlessingAi,
      setSenderBlessingAi = _useCreateAiContext.setSenderBlessingAi,
      setLimitAiImages = _useCreateAiContext.setLimitAiImages;

  var _useState = (0,react.useState)(""),
      initialSenderBlessingAi = _useState[0],
      setInitialSenderBlessingAi = _useState[1];

  var tmpBlessing = "";
  (0,react.useEffect)(function () {
    var getSettings = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,api.getAiImageAiSetting)();

              case 2:
                res = _context.sent;

                if (res.data.errorCode === 0) {
                  setInitialSenderBlessingAi(res.data.body.defaultText);
                  setLimitAiImages(res.data.body.maxGenerate);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getSettings() {
        return _ref.apply(this, arguments);
      };
    }();

    getSettings();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SenderAi_StyledTitleContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SenderAi_StyledTitle, {
        children: "\u05E8\u05D5\u05E6\u05D4 \u05DC\u05DB\u05EA\u05D5\u05D1 \u05DE\u05E9\u05D4\u05D5?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SenderAi_StyledExplanation, {
        children: ["\u05D1\u05DE\u05D9\u05D3\u05D4 \u05D5\u05DC\u05D0 \u05DB\u05EA\u05D1\u05EA \u05DE\u05E1\u05E8, \u05E0\u05E9\u05DC\u05D7 \u05D1\u05E9\u05DE\u05DA \u05DE\u05E1\u05E8 \u05DE\u05D5\u05DB\u05DF \u05DE\u05D0\u05D9\u05EA\u05E0\u05D5", " "]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBlessingAiValue, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/img/icons/ai-logo.svg",
        width: 24,
        height: 24,
        alt: ""
      }), senderBlessingAi.length > 0 ? senderBlessingAi : initialSenderBlessingAi]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormikForm/* default */.Z, {
      validate: function validate(values) {
        setSenderBlessingAi(values.senderBlessingAi);
      },
      validationSchema: validationSchema,
      initialValues: initialValues,
      onSubmit: /*#__PURE__*/function () {
        var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(values) {
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  console.log(values);

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }(),
      alwaysValidate: true,
      render: function render(formik) {
        tmpBlessing = formik === null || formik === void 0 ? void 0 : formik.values.senderBlessingAi;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormContainer, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormInput, {
            name: "senderBlessingAi",
            label: "\u05DB\u05EA\u05D9\u05D1\u05EA \u05DE\u05D9\u05DC\u05D9\u05DD \u05DC\u05E6\u05D3 \u05D4\u05EA\u05DE\u05D5\u05E0\u05D4",
            type: "text",
            InputProps: {
              multiline: true
            },
            minRows: 4,
            maxLength: 20,
            topMargin: lib/* isDesktop */.nI && "0",
            id: "senderBlessingAi",
            value: senderBlessingAi || null
          })
        });
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTextBox, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTypography, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
          component: "span",
          children: (senderBlessingAi === null || senderBlessingAi === void 0 ? void 0 : senderBlessingAi.length) || 0
        }), "/20"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledText, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NextLink/* default */.Z, {
          href: "/ethics",
          onClick: function onClick() {
            setSenderBlessingAi(tmpBlessing);
          },
          children: "\u05D4\u05E7\u05D5\u05D3 \u05D4\u05D0\u05EA\u05D9 \u05E9\u05DC\u05E0\u05D5"
        }), "\u05DC\u05DB\u05EA\u05D9\u05D1\u05EA \u05E0\u05D0\u05D5\u05EA\u05D4"]
      })]
    })]
  });
};

/* harmony default export */ var CreateAi_SenderAi = (SenderAi);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(64436);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/internal/SwitchBase.js
var SwitchBase = __webpack_require__(56608);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js + 1 modules
var createSvgIcon = __webpack_require__(594);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonUnchecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonUnchecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked'));
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonChecked.js


/**
 * @ignore - internal component.
 */

/* harmony default export */ var RadioButtonChecked = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/react.createElement("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked'));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/RadioButtonIcon.js






var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      '&$checked $layer': {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  var checked = props.checked,
      classes = props.classes,
      fontSize = props.fontSize;
  return /*#__PURE__*/react.createElement("div", {
    className: (0,clsx_m/* default */.Z)(classes.root, checked && classes.checked)
  }, /*#__PURE__*/react.createElement(RadioButtonUnchecked, {
    fontSize: fontSize
  }), /*#__PURE__*/react.createElement(RadioButtonChecked, {
    fontSize: fontSize,
    className: classes.layer
  }));
}

 false ? 0 : void 0;
/* harmony default export */ var Radio_RadioButtonIcon = ((0,withStyles/* default */.Z)(styles, {
  name: 'PrivateRadioButtonIcon'
})(RadioButtonIcon));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(59693);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(93871);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(82568);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroupContext.js
var RadioGroupContext = __webpack_require__(79305);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/useRadioGroup.js


function useRadioGroup() {
  return react.useContext(RadioGroupContext/* default */.Z);
}
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js













var Radio_styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: (0,colorManipulator/* alpha */.Fq)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/react.createElement(Radio_RadioButtonIcon, {
  checked: true
});
var defaultIcon = /*#__PURE__*/react.createElement(Radio_RadioButtonIcon, null);
var Radio = /*#__PURE__*/react.forwardRef(function Radio(props, ref) {
  var checkedProp = props.checked,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      nameProp = props.name,
      onChangeProp = props.onChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = (0,objectWithoutProperties/* default */.Z)(props, ["checked", "classes", "color", "name", "onChange", "size"]);

  var radioGroup = useRadioGroup();
  var checked = checkedProp;
  var onChange = (0,createChainedFunction/* default */.Z)(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/react.createElement(SwitchBase/* default */.Z, (0,esm_extends/* default */.Z)({
    color: color,
    type: "radio",
    icon: /*#__PURE__*/react.cloneElement(defaultIcon, {
      fontSize: size === 'small' ? 'small' : 'medium'
    }),
    checkedIcon: /*#__PURE__*/react.cloneElement(defaultCheckedIcon, {
      fontSize: size === 'small' ? 'small' : 'medium'
    }),
    classes: {
      root: (0,clsx_m/* default */.Z)(classes.root, classes["color".concat((0,capitalize/* default */.Z)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Radio_Radio = ((0,withStyles/* default */.Z)(Radio_styles, {
  name: 'MuiRadio'
})(Radio));
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js + 1 modules
var RadioGroup = __webpack_require__(37661);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
;// CONCATENATED MODULE: ./components/CreateAi/StylesAi.tsx












var StylesAi_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h2",
  variant: "h2"
}).withConfig({
  displayName: "StylesAi__StyledTitle",
  componentId: "sc-gpj17d-0"
})(["color:", ";white-space:nowrap;font-size:26px;line-height:0.6;font-family:Speedee,NarkisBlock,sans-serif;margin-bottom:16px;text-align:right;"], colors/* default.black */.Z.black);
var StyledFormControlLabel = (0,styled_components_browser_esm/* default */.ZP)(FormControlLabel/* default */.Z).withConfig({
  displayName: "StylesAi__StyledFormControlLabel",
  componentId: "sc-gpj17d-1"
})(["width:104px;height:88px;border-radius:8px;border:1px solid ", ";display:flex;opacity:", ";margin-bottom:16px;margin-left:16px !important;.MuiTypography-root{display:flex;align-items:center;justify-content:center;height:100%;}", "{width:160px;height:135px;margin-left:24px !important;}"], function (p) {
  return p.$isSelected ? colors/* default.black */.Z.black : colors/* default.disabled */.Z.disabled;
}, function (p) {
  return p.$isNotSelected ? "0.5" : "1";
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledRadioGroupContainer = (0,styled_components_browser_esm/* default */.ZP)(RadioGroup/* default */.Z).withConfig({
  displayName: "StylesAi__StyledRadioGroupContainer",
  componentId: "sc-gpj17d-2"
})(["display:flex;flex-direction:row;margin-bottom:40px;position:relative;", "{text-align:right;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StylesAi_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StylesAi__StyledWrapper",
  componentId: "sc-gpj17d-3"
})(["display:flex;justify-content:flex-start;"]);
var StylesAi_StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "StylesAi__StyledError",
  componentId: "sc-gpj17d-4"
})(["color:#d70202;font-size:18px;line-height:1;position:absolute;bottom:-8px;margin:0px;"]);
var StylesAi = /*#__PURE__*/(0,react.forwardRef)(function (_ref, stylesRef) {
  var _styles$, _styles$3, _styles$3$tags;

  var styles = _ref.styles,
      checkValiation = _ref.checkValiation;

  var _useCreateAiContext = (0,CreateAiContext/* useCreateAiContext */.uh)(),
      setStylesData = _useCreateAiContext.setStylesData,
      stylesData = _useCreateAiContext.stylesData;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StylesAi_StyledTitle, {
      "aria-label": "\u05D1\u05D7\u05D9\u05E8\u05EA \u05E1\u05D8\u05D9\u05D9\u05DC \u05DC\u05D1\u05E8\u05DB\u05D4 - \u05E6\u05D9\u05D5\u05E8",
      children: (_styles$ = styles[0]) === null || _styles$ === void 0 ? void 0 : _styles$.name
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StylesAi_StyledWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        "aria-label": "radio-buttons-styles",
        component: "fieldset",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledRadioGroupContainer, {
          "aria-label": "radio-buttons-styles",
          name: "stylesData",
          value: stylesData || null,
          onChange: function onChange(e) {
            var _styles$2;

            setStylesData((_styles$2 = styles[0]) === null || _styles$2 === void 0 ? void 0 : _styles$2.tags.find(function (style) {
              return style.name === e.target.value;
            }).id);
          },
          children: [(_styles$3 = styles[0]) === null || _styles$3 === void 0 ? void 0 : (_styles$3$tags = _styles$3.tags) === null || _styles$3$tags === void 0 ? void 0 : _styles$3$tags.map(function (style, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledFormControlLabel, {
              $isSelected: stylesData === style.id,
              $isNotSelected: stylesData && stylesData != style.id,
              ref: i === 0 ? stylesRef : null,
              value: style.name,
              control: /*#__PURE__*/(0,jsx_runtime.jsx)(Radio_Radio, {}),
              tabIndex: 0,
              label: style.name,
              onKeyDown: function onKeyDown(e) {
                if (e.key === "Enter") {
                  e.preventDefault(); // Prevent default behavior (form submission, etc.)

                  e.currentTarget.querySelector("input").click();
                }
              }
            }, i);
          }), !stylesData && checkValiation && /*#__PURE__*/(0,jsx_runtime.jsx)(StylesAi_StyledError, {
            children: "\u05D9\u05E9 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05E1\u05D8\u05D9\u05D9\u05DC"
          })]
        })
      })
    })]
  });
});
StylesAi.displayName = "StylesAi";
/* harmony default export */ var CreateAi_StylesAi = (StylesAi);
;// CONCATENATED MODULE: ./components/CreateAi/CreateAiPage.tsx






















var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "CreateAiPage__StyledContainer",
  componentId: "sc-1cyqyli-0"
})(["padding:94px 16px 80px 16px;", "{padding:120px 60px 80px 60px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledBackButton = (0,styled_components_browser_esm/* default */.ZP)(BackButton/* default */.Z).withConfig({
  displayName: "CreateAiPage__StyledBackButton",
  componentId: "sc-1cyqyli-1"
})(["margin-bottom:24px;", "{margin-bottom:48px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var CreateAiPage_StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  component: "h1",
  variant: "h1"
}).withConfig({
  displayName: "CreateAiPage__StyledTitle",
  componentId: "sc-1cyqyli-2"
})(["color:", ";white-space:nowrap;font-size:40px;line-height:0.6;font-family:Speedee,NarkisBlock,sans-serif;height:40px;display:flex;align-items:center;gap:8px;margin-bottom:8px;"], colors/* default.black */.Z.black);
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CreateAiPage__StyledContent",
  componentId: "sc-1cyqyli-3"
})(["margin-bottom:40px;", "{margin-bottom:60px;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var CreateAiPage_StyledExplanation = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "CreateAiPage__StyledExplanation",
  componentId: "sc-1cyqyli-4"
})(["font-size:20px;font-weight:100;color:#000;line-height:0.92;text-align:right;margin-bottom:4px;", "{font-size:18px;}", "{margin-bottom:8px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledInfo = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body2"
}).withConfig({
  displayName: "CreateAiPage__StyledInfo",
  componentId: "sc-1cyqyli-5"
})(["font-size:14px;display:flex;align-items:center;gap:4px;color:", ";", "{font-size:18px;}"], colors/* default.black */.Z.black, function (p) {
  return p.theme.breakpoints.up("md");
});
var CreateAiPage_StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "CreateAiPage__StyledError",
  componentId: "sc-1cyqyli-6"
})(["color:#d70202;font-size:20px;text-align:right;line-height:1.1;margin:0px;"]);

var CreateAiPage = function CreateAiPage() {
  var _useCreateAiContext = (0,CreateAiContext/* useCreateAiContext */.uh)(),
      blessingId = _useCreateAiContext.blessingId,
      postAiImage = _useCreateAiContext.postAiImage,
      setSessionId = _useCreateAiContext.setSessionId,
      stylesData = _useCreateAiContext.stylesData,
      propertiesData = _useCreateAiContext.propertiesData,
      backgroundsData = _useCreateAiContext.backgroundsData;

  var _useState = (0,react.useState)(),
      categories = _useState[0],
      setCategories = _useState[1];

  var _useState2 = (0,react.useState)(),
      choicesTag = _useState2[0],
      setChoicesTag = _useState2[1];

  var _useState3 = (0,react.useState)(),
      properties = _useState3[0],
      setProperties = _useState3[1];

  var _useState4 = (0,react.useState)(),
      styles = _useState4[0],
      setStyles = _useState4[1];

  var _useState5 = (0,react.useState)(),
      backgrounds = _useState5[0],
      setBackgrounds = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      checkValiation = _useState6[0],
      setCheckValidation = _useState6[1];

  var _useGroupPurchasesCon = (0,GroupPurchasesContext/* useGroupPurchasesContext */.ZA)(),
      setPrevPath = _useGroupPurchasesCon.setPrevPath;

  (0,react.useEffect)(function () {
    var getAllBlessingCategories = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,api.getAiImageGetAllBlessing)();

              case 2:
                res = _context.sent;
                setCategories(res.data.body);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getAllBlessingCategories() {
        return _ref.apply(this, arguments);
      };
    }();

    getAllBlessingCategories();
    createSessionId();
    setPrevPath("/create-ai");
  }, []);
  (0,react.useEffect)(function () {
    var getOtherData = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var res;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0,api.getAiImageGetAllTagCategory)(blessingId);

              case 2:
                res = _context2.sent;
                setChoicesTag(res.data.body);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getOtherData() {
        return _ref2.apply(this, arguments);
      };
    }();

    getOtherData();
  }, [blessingId]);
  (0,react.useEffect)(function () {
    if (choicesTag) {
      setProperties(choicesTag === null || choicesTag === void 0 ? void 0 : choicesTag.filter(function (tag) {
        return tag.tagCategoryType === "Clean";
      }));
      setStyles(choicesTag === null || choicesTag === void 0 ? void 0 : choicesTag.filter(function (tag) {
        return tag.tagCategoryType === "Square";
      }));
      setBackgrounds(choicesTag === null || choicesTag === void 0 ? void 0 : choicesTag.filter(function (tag) {
        return tag.tagCategoryType === "Image";
      }));
    }
  }, [choicesTag]);

  var createSessionId = function createSessionId() {
    var sessionId = localStorage.getItem("sessionId");

    if (!sessionId) {
      createTimeStampAndSessionId();
    } else {
      setSessionId(sessionId);
      var storedTimestamp = new Date(JSON.parse(localStorage.getItem("timestamp")));
      var timeDifference = new Date().getTime() - storedTimestamp.getTime();

      if (timeDifference >= 10800000) {
        createTimeStampAndSessionId();
      }
    }
  };

  var createTimeStampAndSessionId = function createTimeStampAndSessionId() {
    var generatedUUID = esm_browser_v4();
    localStorage.setItem("sessionId", JSON.stringify(generatedUUID));
    var timestamp = new Date().toISOString();
    localStorage.setItem("timestamp", JSON.stringify(timestamp));
    setSessionId(JSON.stringify(generatedUUID));
  };

  var ref = (0,react.useRef)(null);
  var stylesRef = (0,react.useRef)(null);
  var bgRef = (0,react.useRef)(null);

  var submitNewAiGiftCard = function submitNewAiGiftCard() {
    var _ref$current, _stylesRef$current, _bgRef$current;

    setCheckValidation(true);
    propertiesData.length === 0 ? ref === null || ref === void 0 ? void 0 : (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.focus() : propertiesData.length > 0 && !stylesData ? stylesRef === null || stylesRef === void 0 ? void 0 : (_stylesRef$current = stylesRef.current) === null || _stylesRef$current === void 0 ? void 0 : _stylesRef$current.focus() : propertiesData.length > 0 && !backgroundsData && (bgRef === null || bgRef === void 0 ? void 0 : (_bgRef$current = bgRef.current) === null || _bgRef$current === void 0 ? void 0 : _bgRef$current.focus());

    if (stylesData && propertiesData.length > 0 && backgroundsData) {
      postAiImage();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContainer, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledBackButton, {
      linkText: "\u05D7\u05D6\u05E8\u05D4",
      prevPath: "/"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledContent, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CreateAiPage_StyledTitle, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/img/aiIcon.svg",
          width: lib/* isDesktop */.nI ? 40 : 30,
          height: lib/* isDesktop */.nI ? 40 : 30,
          alt: ""
        }), "\u05D9\u05E6\u05D9\u05E8\u05EA \u05EA\u05DE\u05D5\u05E0\u05D4 \u05D1-AI"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAiPage_StyledExplanation, {
        children: "\u05D9\u05E6\u05D9\u05E8\u05EA \u05EA\u05DE\u05D5\u05E0\u05D4 \u05E9\u05DC \u05DE\u05E7\u05D3\u05D5\u05E0\u05DC\u05D3'\u05E1 \u05D1\u05D4\u05EA\u05D0\u05DE\u05D4 \u05D0\u05D9\u05E9\u05D9\u05EA"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledInfo, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/img/icons/infoIcon.svg",
          width: lib/* isDesktop */.nI ? 20 : 14,
          height: lib/* isDesktop */.nI ? 20 : 14,
          alt: "info-icon",
          "aria-label": "\u05DC\u05EA\u05E9\u05D5\u05DE\u05EA \u05DC\u05D9\u05D1\u05DA, \u05D0\u05E4\u05E9\u05E8\u05D5\u05EA \u05DC\u05D9\u05E6\u05D5\u05E8 \u05EA\u05DE\u05D5\u05E0\u05D4 \u05E2\u05D3 4 \u05E0\u05D9\u05E1\u05D9\u05D5\u05E0\u05D5\u05EA \u05D1\u05DC\u05D1\u05D3"
        }), "\u05DC\u05EA\u05E9\u05D5\u05DE\u05EA \u05DC\u05D9\u05D1\u05DA, \u05D0\u05E4\u05E9\u05E8\u05D5\u05EA \u05DC\u05D9\u05E6\u05D5\u05E8 \u05EA\u05DE\u05D5\u05E0\u05D4 \u05E2\u05D3 4 \u05E0\u05D9\u05E1\u05D9\u05D5\u05E0\u05D5\u05EA \u05D1\u05DC\u05D1\u05D3", " "]
      })]
    }), categories && /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAi_CategoriesAi, {
      categories: categories
    }), properties && /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAi_PropertiesAi, {
      ref: propertiesData.length === 0 ? ref : null,
      properties: properties,
      checkValiation: checkValiation
    }), styles && /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAi_StylesAi, {
      ref: stylesRef,
      styles: styles,
      checkValiation: checkValiation
    }), backgrounds && /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAi_BackgroundsAi, {
      ref: bgRef,
      backgrounds: backgrounds,
      checkValiation: checkValiation
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAi_SenderAi, {}), (!stylesData || propertiesData.length === 0 || !backgroundsData) && checkValiation && /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAiPage_StyledError, {
      children: "\u05D9\u05E9 \u05E9\u05D3\u05D4 \u05D0\u05D7\u05D3 \u05D0\u05D5 \u05D9\u05D5\u05EA\u05E8 \u05E9\u05DC\u05D0 \u05D1\u05D7\u05E8\u05EA"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreatePictureAiButton/* default */.Z, {
      submit: submitNewAiGiftCard,
      enabledButton: false,
      text: "\u05D9\u05E6\u05D9\u05E8\u05EA \u05EA\u05DE\u05D5\u05E0\u05D4"
    })]
  });
};

/* harmony default export */ var CreateAi_CreateAiPage = (CreateAiPage);
;// CONCATENATED MODULE: ./src/pages/create-ai/index.tsx






var CreateAi = function CreateAi() {
  var seo = {
    title: "יצירת תמונה ב-AI",
    description: "חדש! יצירת תמונה של מקדונלד׳ס בהתאמה אישית",
    keywords: "יצירת תמונה ב-AI"
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
      data: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAi_CreateAiPage, {})]
  });
};

/* harmony default export */ var create_ai = (CreateAi);

/***/ }),

/***/ 30497:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-ai",
      function () {
        return __webpack_require__(80041);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7942)


/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2726,2198,7072,2807,9774,2888,179], function() { return __webpack_exec__(30497); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);